// Controlled vocabulary for venue-relative locations used by:
//   - venue_house_feeds.location_label  (where each house feed terminates)
//   - memberships.service_location_label (where each Overdrive service
//                                         wants to land at load-in)
//
// The dyno-pwa surfaces these as grouped dropdown options plus an
// "Other…" escape hatch for venue-specific labels not on the standard
// list. Stored as free-text in the DB; the backend's clustering uses a
// substring-based group classification, so custom values fall into the
// "unknown / custom" group and only cluster with exact-string matches.
//
// Groups are ordered from upstage (back of the stage) to downstage
// (front) to house (audience-facing) to operations (everything else),
// roughly matching how a load-in walks the venue. Keep this in sync
// with feed_clustering._LOCATION_GROUP_KEYS in the backend — when adding
// new vocabulary entries, ensure the first word of each label is
// already a known substring there.

export interface VenueLocationGroup {
  label: string;
  options: string[];
}

export const VENUE_LOCATION_GROUPS: VenueLocationGroup[] = [
  {
    label: "Stage (deck)",
    options: [
      "Upstage Left",
      "Upstage Center",
      "Upstage Right",
      "Downstage Left",
      "Downstage Center",
      "Downstage Right",
    ],
  },
  {
    label: "Catwalk",
    options: [
      "Catwalk Upstage Left",
      "Catwalk Upstage Center",
      "Catwalk Upstage Right",
      "Catwalk Downstage Left",
      "Catwalk Downstage Center",
      "Catwalk Downstage Right",
      "Catwalk House Left",
      "Catwalk House Right",
    ],
  },
  {
    label: "House",
    options: [
      "Front of House (FOH)",
      "House Left",
      "House Right",
      "House Center",
    ],
  },
  {
    label: "Operations",
    options: [
      "Loading Dock",
      "Loading Dock A",
      "Loading Dock B",
      "Backstage",
      "Dressing Rooms",
      "Production Office",
    ],
  },
];

export const ALL_VENUE_LOCATIONS: string[] = VENUE_LOCATION_GROUPS.flatMap(
  (g) => g.options,
);
